import * as Yup from 'yup';
import { 
    stringWithNoSpecialChars, 
    validateNumericId, 
    validateDate 
} from "@/Shared/Helpers";

import { PublicationEnums } from '@/Shared/Types';

export type PublicationFormValues = {
    adSourceType: string;
    adSourceCategory: string;
    propertyId?: number | null;
    firstPostedAt: string;
    endPostedAt?: string | null;
    firstPostedBy: number | null;
    endPostedBy?: number | null;
    note?: string | null;
};

export const PublicationValidationSchema = (viewEnums: PublicationEnums) => Yup.object({
    adSourceType: Yup.string()
        .required("Le type de l'annonce est requis.")
        .oneOf(viewEnums.AdSourceTypeEnum.map(t => t.value as string), "Type de l'annonce invalide."),

    adSourceCategory: Yup.string()
        .required("La catégorie de l'annonce est requise.")
        .oneOf(viewEnums.AdSourceCategoryEnum.map(c => c.value as string), "Catégorie de l'annonce invalide."),

    propertyId: validateNumericId().required("Le bien associé est requis."),

    firstPostedAt: validateDate().required("La date de première publication est requise."),

    endPostedAt: validateDate().notRequired(),

    firstPostedBy: validateNumericId().required("L'agent qui a publié est requis."),

    endPostedBy: validateNumericId().notRequired(),

    note: stringWithNoSpecialChars({ maxLength: 255 }).notRequired(),
});
